module.exports = __webpack_public_path__ + "img/video-player/replay-7f810fdb6dac6965e5422eb5d4d9db70.svg";